<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('customerInformationSettings')|capitalize }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-switch v-model="botConfig['allowSupporterEditCrm']" v-on:change="updateAllowSupporterEditCustomerInfoConfig" :false-value="'0'" :true-value="'1'">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('allowSupporterEditCustomerInformation')|capitalize }}: <strong
                                                :class="botConfig['allowSupporterEditCrm']==='1'?'success--text':'error--text'">{{$t(botConfig['allowSupporterEditCrm']==='1'?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-switch v-model="botConfig['agentAllowBlockSender']" v-on:change="updateAllowSupporterBlockCustomerConfig">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('allowSupporterBlockCustomer')|capitalize }}: <strong
                                                :class="botConfig['agentAllowBlockSender']?'success--text':'error--text'">{{$t(botConfig['agentAllowBlockSender']?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <div class="chat_view_loading" v-if="loadingDialog">
                <div class="loading_overlay"></div>
                <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import BotService from "@/services/bot.service";
import {mapMutations, mapState} from "vuex";

export default {
        name: "CustomerInformationSetting",
        props: {
            botCode: String,
        },
        computed: {
            ...mapState('config', ['botConfig'])
        },
        data () {
            return {
                loadingDialog: false,
            }
        },
        methods: {
            ...mapMutations('config', ['setBotConfig']),
            updateAllowSupporterEditCustomerInfoConfig() {
                this.loadingDialog = true;
                BotService.updateAllowEditCRMSetting(this.botCode, this.botConfig['allowSupporterEditCrm'])
                    .then(() => {
                        this.setBotConfig({allow_supporter_edit_crm: this.botConfig['allowSupporterEditCrm']});
                        this.$AppService.toastSuccess("Update config success.");
                    })
                    .catch(() => {
                        this.$AppService.toastError("Update config failed");
                        this.botConfig['allowSupporterEditCrm'] = !this.botConfig['allowSupporterEditCrm'];
                    })
                    .finally(() => {
                        this.loadingDialog = false;
                    })
            },
            updateAllowSupporterBlockCustomerConfig() {
                this.loadingDialog = true;
                let configValue = this.botConfig['agentAllowBlockSender'] ? "1" : 0
                BotService.updateAllowBlockCustomerSetting(this.botCode, configValue)
                    .then(() => {
                        this.setBotConfig({agent_allow_block_sender: this.botConfig['agentAllowBlockSender']});
                        this.$AppService.toastSuccess("Update config success.");
                    })
                    .catch(() => {
                        this.$AppService.toastError("Update config failed");
                        this.botConfig['agentAllowBlockSender'] = !this.botConfig['agentAllowBlockSender'];
                    })
                    .finally(() => {
                        this.loadingDialog = false;
                    })
            },

        },
    }
</script>


<style scoped lang="scss">
.chat_view_loading {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 99999;
    align-items: center;
    text-align: center;
    padding-top: 27%;

    .loading_overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        background-color: black;
        opacity: 0.2;
    }
}
</style>
